import { defineRecipe } from "@chakra-ui/react";

export const ContainerStyles = defineRecipe({
  base: {
    px: ".75rem", // Padding left/right
  },
});
